import { NgModule } from '@angular/core';

import { IconModule } from './../../common/icon/icon.module';
import { RadioComponent } from './radio.component';

@NgModule({
  declarations: [RadioComponent],
  exports: [RadioComponent],
  imports: [IconModule],
})
export class RadioModule {}
export { RadioComponent } from './radio.component';
